
const state = {
	ids: []										// 运单号或预约单号
};

const getters = {

};

const mutations = {

};

const actions = {

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/waybill.js